import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../../store/useAuthStore';
import './ProductSettingsDrawer.css';
import {clearNavStack, smartNavigate} from "../../../utils/smartNavigate";

// Only keep the used icon components
const LogOutIcon = () => (
  <img src="/images/ui/log-out.png" alt="Log Out" width={22} height={22} className="drawer-logout-icon" />
);
const ChevronRightIcon = () => (
  <svg width="22" height="22" fill="none" stroke="#B0B3B9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 5-6 5"/></svg>
);

interface ProductSettingsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProductSettingsDrawer: React.FC<ProductSettingsDrawerProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const logout = useAuthStore(state => state.logout);

  const accountItems = [
    { icon: '/images/ui/credit-card.png', label: t('product.settings.account.subscription'), path: '/subscription' },
    // { icon: '/images/ui/mail.png', label: t('product.settings.account.changeEmail'), path: '/change-email' },
    { icon: '/images/ui/message-circle.png', label: t('product.settings.account.leaveFeedback'), path: '/feedback' },
    { icon: '/images/ui/earth.png', label: t('product.settings.account.appLanguage'), path: '/language' },
    { icon: '/images/ui/bin.png', label: t('product.settings.account.deleteAccount'), path: '/delete-account' },
  ];

  const aboutItems = [
    { icon: '/images/ui/files.png', label: t('product.settings.about.termsAndConditions'), path: '/terms' },
    { icon: '/images/ui/lock-keyhole.png', label: t('product.settings.about.privacyPolicy'), path: '/privacy' },
    { icon: '/images/ui/file-text.png', label: t('product.settings.about.subscriptionTerms'), path: '/subscription-terms' },
  ];

  const handleLogout = () => {
    onClose(); // Close the drawer first
    logout(); // Then logout
  };

  return (
    <div className={`drawer-overlay ${isOpen ? 'open' : 'closed'}`}>
      <div className={`drawer-panel ${isOpen ? 'open' : 'closed'}`}>
        {/* Title bar */}
        <div className="drawer-titlebar">
          <button onClick={onClose} className="drawer-back-btn">
            {/* Back icon */}
            <img
                src="/images/arrow-left.png"
                alt="Back"
                width="24"
                height="24"
            />
          </button>
          <div className="drawer-title">{t('product.settings.title')}</div>
          <div className="drawer-titlebar-spacer" />
        </div>
        {/* Account Section */}
        <div className="drawer-section">
          <div className="drawer-section-title">{t('product.settings.account.title')}</div>
          <div className="drawer-list">
            {accountItems.map((item) => (
              <div
                key={item.label}
                className="drawer-list-item"
                onClick={() => {
                  onClose();
                  clearNavStack();
                  smartNavigate(item.path);
                }}
              >
                <span className="drawer-list-icon">
                  <img src={item.icon} alt={item.label} />
                </span>
                <span className="drawer-list-label">{item.label}</span>
                <ChevronRightIcon />
              </div>
            ))}
          </div>
        </div>
        {/* About Section */}
        <div className="drawer-about-section">
          <div className="drawer-section-title">{t('product.settings.about.title')}</div>
          <div className="drawer-list">
            {aboutItems.map((item) => (
              <div
                key={item.label}
                className="drawer-list-item"
                onClick={() => {
                  onClose();
                  clearNavStack();
                  smartNavigate(item.path);
                }}
              >
                <span className="drawer-list-icon">
                  <img src={item.icon} alt={item.label} />
                </span>
                <span className="drawer-list-label">{item.label}</span>
                <ChevronRightIcon />
              </div>
            ))}
          </div>
        </div>
        {/* Log Out Button */}
        <div className="drawer-logout-section">
          <button
            onClick={handleLogout}
            className="drawer-logout-btn"
          >
            <LogOutIcon />
            {t('product.profile.logOut')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductSettingsDrawer;
